import { apiGet, apiPost, apiPut, apiDelete, apiPatch } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export default {
  // Create new specialties
  createSpecialties: (payload) => apiPost(domainUrl(`/v1/specialty`), payload),
  
  // Get all specialties with pagination and filters
  getSpecialtiesList: (size=5000, current=1) => apiGet(domainUrl(`/v1/specialty?limit=${size}&page=${current}`)),
  
  // Get a specific specialty by ID
  getSpecialtyById: (id) => apiGet(domainUrl(`/v1/specialty/${id}`)),
  
  // Update an existing specialty
  updateSpecialty: (id, payload) => apiPatch(domainUrl(`/v1/specialty/${id}`), payload),
  
  // Delete specialty
  deleteSpecialty: (payload) => apiPost(domainUrl(`/v1/specialty/delete`), payload),
};
